import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/gyqx2.jpg';
import _imports_1 from '@/assets/ewm.png';
import _imports_2 from '@/assets/gzh.jpg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-349556ae"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "margin": "auto",
    "display": "flex",
    "flex-direction": "row"
  }
};
var _hoisted_2 = {
  class: "center"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {
      "width": "100%",
      "height": "100%"
    }
  })], -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "fromstyle-wz"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "wz-zun"
  }, "尊敬的参与者："), /*#__PURE__*/_createElementVNode("span", {
    class: "wz-nei"
  }, "您好！我司正在进行一项关于等离子清洗、干冰清洗相关工业清洗设备的市场调研，旨在深入了解您公司在工业清洗技术方面的应用现状、需求及面临的挑战。 您的反馈将对我们产品的优化与升级起到至关重要的作用。请您根据实际情况，选择或填写最合适的答案。"), /*#__PURE__*/_createElementVNode("span", {
    class: "wz-nei"
  }, " 预计完成本问卷需要5-10分钟，我们承诺所有信息将严格保密。 ")], -1);
});

var _hoisted_5 = {
  class: "zheng"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "请先填写您的基本信息")])], -1);
});

var _hoisted_7 = {
  class: "bottom",
  style: {
    "padding-right": "15px"
  }
};
var _hoisted_8 = {
  class: "zheng"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "1、贵单位所属行业（单选）")])], -1);
});

var _hoisted_10 = {
  class: "bottom"
};

var _hoisted_11 = /*#__PURE__*/_createTextVNode("电子制造");

var _hoisted_12 = /*#__PURE__*/_createTextVNode("半导体生产");

var _hoisted_13 = /*#__PURE__*/_createTextVNode("医疗器械");

var _hoisted_14 = /*#__PURE__*/_createTextVNode("航空航天");

var _hoisted_15 = /*#__PURE__*/_createTextVNode("汽车制造");

var _hoisted_16 = /*#__PURE__*/_createTextVNode("鞋服纺织");

var _hoisted_17 = /*#__PURE__*/_createTextVNode("包装行业");

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_19 = ["disabled"];
var _hoisted_20 = {
  class: "zheng"
};

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "2、目前贵企业主要采用哪些清洗方法？（可多选）")])], -1);
});

var _hoisted_22 = {
  class: "bottom"
};

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_24 = ["disabled"];
var _hoisted_25 = {
  class: "zheng"
};

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "3、现有清洗方法主要应用于哪些产品或零部件的清洗？（可多选）")])], -1);
});

var _hoisted_27 = {
  class: "bottom"
};

var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_29 = ["disabled"];
var _hoisted_30 = {
  class: "zheng"
};

var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "4、需要清洗掉什么类型的物质？")])], -1);
});

var _hoisted_32 = {
  class: "bottom"
};

var _hoisted_33 = /*#__PURE__*/_createTextVNode("油脂类：动植物油脂类、矿物油");

var _hoisted_34 = /*#__PURE__*/_createTextVNode("聚合物残留：聚苯乙烯、聚丙烯等塑料熔体");

var _hoisted_35 = /*#__PURE__*/_createTextVNode("有机污垢(含碳氢化合物):碳黑污垢、有机颜料污垢");

var _hoisted_36 = /*#__PURE__*/_createTextVNode("金属氧化物：铁锈（氧化铁）、氧化铝");

var _hoisted_37 = /*#__PURE__*/_createTextVNode("无机盐垢：碳酸钙、碳酸镁垢，硫酸钙垢");

var _hoisted_38 = /*#__PURE__*/_createTextVNode("灰尘和泥沙等固体颗粒等");

var _hoisted_39 = /*#__PURE__*/_createTextVNode("包装行业");

var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_41 = ["disabled"];
var _hoisted_42 = {
  class: "zheng"
};

var _hoisted_43 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "5、在当前清洗过程中，您认为最主要的痛点是什么？（可多选）")])], -1);
});

var _hoisted_44 = {
  class: "bottom"
};

var _hoisted_45 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_46 = ["disabled"];
var _hoisted_47 = {
  class: "zheng"
};

var _hoisted_48 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "6、清洗主要应用在哪些工艺预处理的场景中？（可多选）")])], -1);
});

var _hoisted_49 = {
  class: "bottom"
};

var _hoisted_50 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_51 = ["disabled"];
var _hoisted_52 = {
  class: "zheng"
};

var _hoisted_53 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "7、需要清洗掉什么类型的物质？")])], -1);
});

var _hoisted_54 = {
  class: "bottom"
};

var _hoisted_55 = /*#__PURE__*/_createTextVNode("了解一些基本原理和应用");

var _hoisted_56 = /*#__PURE__*/_createTextVNode("仅听说过名称");

var _hoisted_57 = /*#__PURE__*/_createTextVNode("完全不了解");

var _hoisted_58 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "非常了解，使用设备品牌", -1);
});

var _hoisted_59 = ["disabled"];
var _hoisted_60 = {
  key: 0,
  class: "zheng"
};

var _hoisted_61 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "8、生产过程中遇到的困难在使用等离子清洗设备的过程中，贵司常遇到的困难或挑战有哪些？（可多选）")])], -1);
});

var _hoisted_62 = {
  class: "bottom"
};

var _hoisted_63 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_64 = ["disabled"];
var _hoisted_65 = {
  key: 1,
  class: "zheng"
};

var _hoisted_66 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "8、在未来的生产或业务拓展中，您是否考虑采用干法清洗解决方案？")])], -1);
});

var _hoisted_67 = {
  class: "bottom"
};

var _hoisted_68 = /*#__PURE__*/_createTextVNode("肯定会考虑，正在寻找合适的供应商");

var _hoisted_69 = /*#__PURE__*/_createTextVNode("可能会考虑，需要进一步了解相关信息");

var _hoisted_70 = /*#__PURE__*/_createTextVNode("不确定，要看具体情况和成本效益");

var _hoisted_71 = /*#__PURE__*/_createTextVNode("不太可能考虑，认为现有清洗方法已足够");

var _hoisted_72 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "绝对不会考虑，有其他顾虑（请注明）", -1);
});

var _hoisted_73 = ["disabled"];
var _hoisted_74 = {
  class: "zheng"
};

var _hoisted_75 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "9、若选择工业清洗供应商，您最看重的因素是什么？（可多选）")])], -1);
});

var _hoisted_76 = {
  class: "bottom"
};

var _hoisted_77 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_78 = ["disabled"];
var _hoisted_79 = {
  class: "zheng"
};

var _hoisted_80 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "10、对于干法清洗解决方案，您最期望它能解决当前清洗过程中的哪些关键问题？（可多选）")])], -1);
});

var _hoisted_81 = {
  class: "bottom"
};

var _hoisted_82 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_83 = ["disabled"];
var _hoisted_84 = {
  class: "zheng"
};

var _hoisted_85 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "11、您是否愿意参与产品等离子清洗Demo或干冰清洗Demo？")])], -1);
});

var _hoisted_86 = {
  class: "bottom"
};

var _hoisted_87 = /*#__PURE__*/_createTextVNode("是");

var _hoisted_88 = /*#__PURE__*/_createTextVNode("否");

var _hoisted_89 = {
  class: "zheng"
};

var _hoisted_90 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "12、您是否有其他关于等离子清洗技术或设备的建议、需求或问题想要分享？[请在此区域详细填写您的反馈或问题]")])], -1);
});

var _hoisted_91 = {
  class: "bottom",
  style: {
    "margin-right": "10px"
  }
};

var _hoisted_92 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "fromstyle-wz"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "wz-nei",
    style: {
      "font-weight": "600"
    }
  }, " 非常感谢您抽出宝贵时间完成此问卷！您的意见对我们至关重要，将帮助我们不断优化产品，更好地服务于半导体行业。如有任何其他问题或需要进一步交流，请随时联系我们。我们承诺将您的反馈视为宝贵的资源，并致力于为您提供更优质的产品与服务。 此问卷经过调整，确保问题的准确性和针对性，以便收集到更有价值的数据。希望贵司能够积极参与，为我们的产品改进与升级提供宝贵的建议与需求。 ")], -1);
});

var _hoisted_93 = {
  class: "bottoms"
};
var _hoisted_94 = {
  class: "bottom-btn"
};

var _hoisted_95 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "dibu"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "dibu-kuan"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "display": "flex"
    }
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "参与问卷调研，共创未来！感谢您的支持与合作！")])])], -1);
});

var _hoisted_96 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })], -1);
});

var _hoisted_97 = [_hoisted_96];
var _hoisted_98 = {
  class: "model"
};

var _hoisted_99 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "zhe"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "zhe-tu"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    style: {
      "width": "175px",
      "height": "175px"
    }
  })]), /*#__PURE__*/_createElementVNode("div", {
    class: "zhe-wen"
  }, " 关注公众号，了解更多丰富内容！ ")], -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_radio = _resolveComponent("el-radio");

  var _component_el_radio_group = _resolveComponent("el-radio-group");

  var _component_el_checkbox = _resolveComponent("el-checkbox");

  var _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: "main",
    style: _normalizeStyle('padding-top:' + $data.mainpadding + 'px;')
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass({
      'centerShow': $data.bwidth
    })
  }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
    class: _normalizeClass($data.phoneShow ? 'fromstyle1' : 'fromstyle')
  }, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
    modelValue: $data.bus.company,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.bus.company = $event;
    }),
    placeholder: "请输入您的公司名称"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
    modelValue: $data.bus.contact,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.bus.contact = $event;
    }),
    placeholder: "联系人",
    style: {
      "margin": "10px 0px"
    }
  }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
    modelValue: $data.bus.phone,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.bus.phone = $event;
    }),
    placeholder: "联系电话"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
    modelValue: $data.bus.position,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.bus.position = $event;
    }),
    placeholder: "请输入您的职务",
    style: {
      "margin": "10px 0px"
    }
  }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
    modelValue: $data.bus.email,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.bus.email = $event;
    }),
    placeholder: "请输入您的电子邮箱"
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_radio_group, {
    modelValue: $data.singlechoice1,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return $data.singlechoice1 = $event;
    }),
    class: "ml-4"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: "电子制造"
      }, {
        default: _withCtx(function () {
          return [_hoisted_11];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "半导体生产"
      }, {
        default: _withCtx(function () {
          return [_hoisted_12];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "医疗器械"
      }, {
        default: _withCtx(function () {
          return [_hoisted_13];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "航空航天"
      }, {
        default: _withCtx(function () {
          return [_hoisted_14];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "汽车制造"
      }, {
        default: _withCtx(function () {
          return [_hoisted_15];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "鞋服纺织"
      }, {
        default: _withCtx(function () {
          return [_hoisted_16];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "包装行业"
      }, {
        default: _withCtx(function () {
          return [_hoisted_17];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "其它"
      }, {
        default: _withCtx(function () {
          return [_hoisted_18, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return $data.tk.suggestions1 = $event;
            }),
            disabled: $data.singlechoice1 != '其它'
          }, null, 8, _hoisted_19), [[_vModelText, $data.tk.suggestions1]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice1,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
      return $data.dx.multiplechoice1 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData2, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[8] || (_cache[8] = function ($event) {
          return $options.xz2($event, 1);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_23, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
              return $data.tk.suggestions2 = $event;
            }),
            disabled: $options.tk2()
          }, null, 8, _hoisted_24), [[_vModelText, $data.tk.suggestions2]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice2,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
      return $data.dx.multiplechoice2 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData3, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[11] || (_cache[11] = function ($event) {
          return $options.xz3($event, 1);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_28, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
              return $data.tk.suggestions3 = $event;
            }),
            disabled: $options.tk3()
          }, null, 8, _hoisted_29), [[_vModelText, $data.tk.suggestions3]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, [_createVNode(_component_el_radio_group, {
    modelValue: $data.singlechoice2,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
      return $data.singlechoice2 = $event;
    }),
    class: "ml-4",
    onChange: _cache[15] || (_cache[15] = function ($event) {
      return $options.xz4($event);
    })
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: "油脂类：动植物油脂类、矿物油"
      }, {
        default: _withCtx(function () {
          return [_hoisted_33];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "聚合物残留：聚苯乙烯、聚丙烯等塑料熔体"
      }, {
        default: _withCtx(function () {
          return [_hoisted_34];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "有机污垢(含碳氢化合物):碳黑污垢、有机颜料污垢"
      }, {
        default: _withCtx(function () {
          return [_hoisted_35];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "金属氧化物：铁锈（氧化铁）、氧化铝"
      }, {
        default: _withCtx(function () {
          return [_hoisted_36];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "无机盐垢：碳酸钙、碳酸镁垢，硫酸钙垢"
      }, {
        default: _withCtx(function () {
          return [_hoisted_37];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "灰尘和泥沙等固体颗粒等"
      }, {
        default: _withCtx(function () {
          return [_hoisted_38];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "包装行业"
      }, {
        default: _withCtx(function () {
          return [_hoisted_39];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "其它"
      }, {
        default: _withCtx(function () {
          return [_hoisted_40, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
              return $data.tk.suggestions4 = $event;
            }),
            disabled: $data.singlechoice2 != '其它'
          }, null, 8, _hoisted_41), [[_vModelText, $data.tk.suggestions4]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_42, [_hoisted_43, _createElementVNode("div", _hoisted_44, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice3,
    "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) {
      return $data.dx.multiplechoice3 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData5, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[17] || (_cache[17] = function ($event) {
          return $options.xz5($event, 1);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_45, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
              return $data.tk.suggestions5 = $event;
            }),
            disabled: $options.tk5()
          }, null, 8, _hoisted_46), [[_vModelText, $data.tk.suggestions5]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_47, [_hoisted_48, _createElementVNode("div", _hoisted_49, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice4,
    "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) {
      return $data.dx.multiplechoice4 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData6, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[20] || (_cache[20] = function ($event) {
          return $options.xz6($event, 1);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_50, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[19] || (_cache[19] = function ($event) {
              return $data.tk.suggestions6 = $event;
            }),
            disabled: $options.tk6()
          }, null, 8, _hoisted_51), [[_vModelText, $data.tk.suggestions6]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_52, [_hoisted_53, _createElementVNode("div", _hoisted_54, [_createVNode(_component_el_radio_group, {
    modelValue: $data.singlechoice3,
    "onUpdate:modelValue": _cache[23] || (_cache[23] = function ($event) {
      return $data.singlechoice3 = $event;
    }),
    class: "ml-4",
    onChange: _cache[24] || (_cache[24] = function ($event) {
      return $options.xz7($event);
    })
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: "了解一些基本原理和应用"
      }, {
        default: _withCtx(function () {
          return [_hoisted_55];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "仅听说过名称"
      }, {
        default: _withCtx(function () {
          return [_hoisted_56];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "完全不了解"
      }, {
        default: _withCtx(function () {
          return [_hoisted_57];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "非常了解，使用设备品牌"
      }, {
        default: _withCtx(function () {
          return [_hoisted_58, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[22] || (_cache[22] = function ($event) {
              return $data.tk.suggestions7 = $event;
            }),
            disabled: $data.singlechoice3 != '非常了解，使用设备品牌'
          }, null, 8, _hoisted_59), [[_vModelText, $data.tk.suggestions7]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), $data.singlechoice3 == '了解一些基本原理和应用' ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_hoisted_61, _createElementVNode("div", _hoisted_62, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice5,
    "onUpdate:modelValue": _cache[27] || (_cache[27] = function ($event) {
      return $data.dx.multiplechoice5 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData8, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[26] || (_cache[26] = function ($event) {
          return $options.xz8($event, 1);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_63, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[25] || (_cache[25] = function ($event) {
              return $data.tk.suggestions8 = $event;
            }),
            disabled: $options.tk8()
          }, null, 8, _hoisted_64), [[_vModelText, $data.tk.suggestions8]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])])) : _createCommentVNode("", true), $data.singlechoice3 != '了解一些基本原理和应用' && $data.singlechoice3 != '' ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_hoisted_66, _createElementVNode("div", _hoisted_67, [_createVNode(_component_el_radio_group, {
    modelValue: $data.singlechoice4,
    "onUpdate:modelValue": _cache[29] || (_cache[29] = function ($event) {
      return $data.singlechoice4 = $event;
    }),
    class: "ml-4",
    onChange: _cache[30] || (_cache[30] = function ($event) {
      return $options.xz9($event);
    })
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: "肯定会考虑，正在寻找合适的供应商"
      }, {
        default: _withCtx(function () {
          return [_hoisted_68];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "可能会考虑，需要进一步了解相关信息"
      }, {
        default: _withCtx(function () {
          return [_hoisted_69];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "不确定，要看具体情况和成本效益"
      }, {
        default: _withCtx(function () {
          return [_hoisted_70];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "不太可能考虑，认为现有清洗方法已足够"
      }, {
        default: _withCtx(function () {
          return [_hoisted_71];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "绝对不会考虑，有其他顾虑（请注明）"
      }, {
        default: _withCtx(function () {
          return [_hoisted_72, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[28] || (_cache[28] = function ($event) {
              return $data.tk.suggestions9 = $event;
            }),
            disabled: $data.singlechoice4 != '绝对不会考虑，有其他顾虑（请注明）'
          }, null, 8, _hoisted_73), [[_vModelText, $data.tk.suggestions9]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_74, [_hoisted_75, _createElementVNode("div", _hoisted_76, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice6,
    "onUpdate:modelValue": _cache[33] || (_cache[33] = function ($event) {
      return $data.dx.multiplechoice6 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData9, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[32] || (_cache[32] = function ($event) {
          return $options.xz10($event, 1);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_77, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[31] || (_cache[31] = function ($event) {
              return $data.tk.suggestions10 = $event;
            }),
            disabled: $options.tk10()
          }, null, 8, _hoisted_78), [[_vModelText, $data.tk.suggestions10]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_79, [_hoisted_80, _createElementVNode("div", _hoisted_81, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice7,
    "onUpdate:modelValue": _cache[36] || (_cache[36] = function ($event) {
      return $data.dx.multiplechoice7 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData10, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[35] || (_cache[35] = function ($event) {
          return $options.xz11($event, 1);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_82, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[34] || (_cache[34] = function ($event) {
              return $data.tk.suggestions11 = $event;
            }),
            disabled: $options.tk11()
          }, null, 8, _hoisted_83), [[_vModelText, $data.tk.suggestions11]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_84, [_hoisted_85, _createElementVNode("div", _hoisted_86, [_createVNode(_component_el_radio_group, {
    modelValue: $data.bus.singlechoice5,
    "onUpdate:modelValue": _cache[37] || (_cache[37] = function ($event) {
      return $data.bus.singlechoice5 = $event;
    }),
    class: "ml-4"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: 1
      }, {
        default: _withCtx(function () {
          return [_hoisted_87];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: 0
      }, {
        default: _withCtx(function () {
          return [_hoisted_88];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_89, [_hoisted_90, _createElementVNode("div", _hoisted_91, [_createVNode(_component_el_input, {
    rows: 5,
    modelValue: $data.bus.singlechoice6,
    "onUpdate:modelValue": _cache[38] || (_cache[38] = function ($event) {
      return $data.bus.singlechoice6 = $event;
    }),
    type: "textarea",
    placeholder: "请输入"
  }, null, 8, ["modelValue"])])]), _hoisted_92], 2), _createElementVNode("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_createElementVNode("div", {
    class: "bottom-tj",
    onClick: _cache[39] || (_cache[39] = function ($event) {
      return $options.busAdd(_ctx.ruleFormRef);
    })
  }, " 提交 ")])])]), _hoisted_95], 2), $data.phoneShow ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "tu",
    onClick: _cache[40] || (_cache[40] = function () {
      return $options.tuShow && $options.tuShow.apply($options, arguments);
    })
  }, _hoisted_97)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_98, [_createVNode(_component_el_dialog, {
    modelValue: $data.imgStatus,
    "onUpdate:modelValue": _cache[41] || (_cache[41] = function ($event) {
      return $data.imgStatus = $event;
    }),
    width: "240px",
    draggable: true,
    "close-on-click-modal": false
  }, {
    default: _withCtx(function () {
      return [_hoisted_99];
    }),
    _: 1
  }, 8, ["modelValue"])])], 4)]);
}